export default __webpack_public_path__ + "static/bean-photo-f06292ea7a29241e9cf7ecf9d2c53395.svg";